export const SET_ORIGINAL_QUOTE = 'edit-booking/SET_ORIGINAL_QUOTE';
export const SET_ORIGINAL_DONATION = 'edit-booking/SET_ORIGINAL_DONATION';
